import {
  actionTypes,
  changePasswordRequestFailure,
  changePasswordRequestSuccess,
  userRequestFailure,
  userRequestSuccess,
  passwordPolicyRequestSuccess,
  passwordPolicyRequestFailure,
  getChangePwdSecurityQuestionsSuccess,
  getChangePwdSecurityQuestionsFailure,
  verifySecurityQuestionsChangePwdSuccess,
  verifySecurityQuestionsChangePwdFailure,
  verifyChangeQuestionsActionSuccess,
  verifyChangeQuestionsActionFailure,
  verifyChangeUigpActionSuccess,
  verifyChangeUigpActionFailure,
  verifyChangeArcotActionSuccess,
  verifyChangeArcotActionFailure,
  forcedChangePwdActionSuccess,
  forcedChangePwdActionFailure,
} from "./actions";

import {
  fetchGetSecurityQuestionsChange,
  fetchPasswordPolicy,
  fetchUserRequest,
  fetchVerifyQuestions,
  forcedChangePwsService,
  verifyArcotChangeService,
  verifySecurityQuestionsChangeService,
  verifyUigpOtpChangeService,
} from "./services";

import { ofType } from "redux-observable";
import { mergeMap, map, catchError } from "rxjs/operators";
import { of } from "rxjs";

const fetchUserRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.USER_REQUEST_CHANGE_PASSWORD),
    mergeMap(() =>
      fetchUserRequest().pipe(
        map((response: any) => userRequestSuccess(response)),
        catchError((error: any) => of(userRequestFailure(error)))
      )
    )
  );

const forcedChangePwdEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.FORCED_CHANGE_PWD),
    mergeMap((action: any) =>
      forcedChangePwsService(action.payload).pipe(
        map((response: any) => forcedChangePwdActionSuccess(response)),
        catchError((error: any) => of(forcedChangePwdActionFailure(error)))
      )
    )
  );

const fetchGetChangePwdSecurityQuestionsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_CHANGE_PWD_QUESTIONS),
    mergeMap((action: any) =>
      fetchGetSecurityQuestionsChange().pipe(
        map((response: any) => getChangePwdSecurityQuestionsSuccess(response)),
        catchError((error: any) =>
          of(getChangePwdSecurityQuestionsFailure(error))
        )
      )
    )
  );

const fetchVerifySecurityQuestionsChangePwdEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.VERIFY_SECURITY_QUESTIONS_CHANGE_PASSWORD),
    mergeMap((action: any) =>
      fetchVerifyQuestions(action.payload).pipe(
        map((response: any) =>
          verifySecurityQuestionsChangePwdSuccess(response)
        ),
        catchError((error: any) =>
          of(verifySecurityQuestionsChangePwdFailure(error))
        )
      )
    )
  );

const fetchPasswordPolicyEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.SET_USER_SELECTED),
    mergeMap((action: any) =>
      fetchPasswordPolicy(action.payload).pipe(
        map((response: any) => passwordPolicyRequestSuccess(response)),
        catchError((error: any) => of(passwordPolicyRequestFailure(error)))
      )
    )
  );

const verifyChangeArcotEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.VERIFY_CHANGE_ARCOT_OTP),
    mergeMap((action: any) =>
      verifyArcotChangeService(action.payload).pipe(
        map((response: any) => verifyChangeArcotActionSuccess(response)),
        catchError((error: any) => of(verifyChangeArcotActionFailure(error)))
      )
    )
  );

const verifyChangeSecurityQuestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.VERIFY_CHANGE_SEC_QUESTIONS),
    mergeMap((action: any) =>
      verifySecurityQuestionsChangeService(action.payload).pipe(
        map((response: any) => verifyChangeQuestionsActionSuccess(response)),
        catchError((error: any) =>
          of(verifyChangeQuestionsActionFailure(error))
        )
      )
    )
  );

const verifyChangeUigpOtpEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.VERIFY_CHANGE_UIGP_OTP),
    mergeMap((action: any) =>
      verifyUigpOtpChangeService(action.payload).pipe(
        map((response: any) => verifyChangeUigpActionSuccess(response)),
        catchError((error: any) => of(verifyChangeUigpActionFailure(error)))
      )
    )
  );

export default [
  fetchUserRequestEpic,
  verifyChangeArcotEpic,
  fetchPasswordPolicyEpic,
  fetchGetChangePwdSecurityQuestionsEpic,
  fetchVerifySecurityQuestionsChangePwdEpic,
  verifyChangeSecurityQuestEpic,
  verifyChangeUigpOtpEpic,
  forcedChangePwdEpic,
];
